// 📂 components/Client/Table/ModuleDetailPanel/ModuleRolesTableRow.tsx
import React, { useState, useEffect } from "react";
import TableCheckbox from "../../../Forms/Input/TableCheckbox";
import { useRole } from "../../../../hooks/useRole";
import { useModule } from "../../../../hooks/module/useModule";

const ModuleRolesTableRow: React.FC = () => {
  const { dropdownOptions, fetchRolesDropdown } = useRole();
  const { moduleDetail, updateModuleRoles, updateFieldLocally } = useModule();

  const [selectedRoles, setSelectedRoles] = useState<string[]>([]);

  // 🚀 Cargar roles si no están cargados
  useEffect(() => {
    if (dropdownOptions.length === 0) fetchRolesDropdown();
  }, []);

  // 🧩 Inicializar los roles del módulo al cargar el detalle
  useEffect(() => {
    if (moduleDetail?.roles) {
      setSelectedRoles(moduleDetail.roles);
    }
  }, [moduleDetail]);

  if (!moduleDetail) {
    return (
      <div className="px-4 py-3 text-center text-gray-500 dark:text-gray-300">
        Cargando roles del módulo...
      </div>
    );
  }

  if (dropdownOptions.length === 0) {
    return (
      <div className="px-4 py-3 text-center text-gray-500 dark:text-gray-300">
        Cargando lista de roles...
      </div>
    );
  }

  // 🔹 Alternar selección de un rol (identidad = código técnico del rol)
  const handleToggle = (roleCode: string) => {
    setSelectedRoles((prev) => {
      const updatedRoles = prev.includes(roleCode)
        ? prev.filter((r) => r !== roleCode)
        : [...prev, roleCode];

      // 1️⃣ Actualiza en Redux localmente (instantáneo)
      updateFieldLocally("roles", updatedRoles);

      // 2️⃣ Enviar al backend (solo IDs)
      const selectedRoleIds = dropdownOptions
        .filter((r) => updatedRoles.includes(r.code ?? r.name))
        .map((r) => r.id);

      updateModuleRoles({
        moduleId: moduleDetail.id,
        roleIds: selectedRoleIds,
      });

      return updatedRoles;
    });
  };

  // 🔹 Render dinámico de roles como checkboxes
  return (
    <div
      className="grid bg-white transition hover:bg-gray-1 dark:bg-boxdark dark:hover:bg-meta-4"
      style={{
        gridTemplateColumns: `repeat(${dropdownOptions.length}, 132px)`,
      }}
    >
      {dropdownOptions.map((role) => {
        const roleCode = role.code ?? role.name;
        return (
          <div key={role.id} className="flex justify-center items-center py-3">
            <TableCheckbox
              checked={selectedRoles.includes(roleCode)}
              onChange={() => handleToggle(roleCode)}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ModuleRolesTableRow;
